import { errorIdentityOf } from "@pandas/logger";
import { retryAfterError } from "@pandas/stale-chunk";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { useEffect } from "react";
import { AlertCircle } from "tabler-icons-react";
import logger from "@/lib/logging/logger";
import { staleChunkRecovery } from "@/lib/staleChunkRecovery";

/** The route error surface, app-wide and on `_app`: a route chunk a redeploy removed spends the one automatic reload instead of stranding the journey here. */
export function AppErrorFallback({ error, reset }: ErrorComponentProps) {
	useEffect(() => {
		if (!staleChunkRecovery.maybeRecoverChunkCrash(error)) {
			logger.error("FLOW", "Unhandled route error", errorIdentityOf(error));
		}
	}, [error]);
	return (
		<div className="flex h-[100dvh] flex-col items-center justify-center gap-4 p-8 text-center">
			<AlertCircle size={64} />
			<h2 className="font-secondary text-xl">Something went wrong</h2>
			<p className="text-sm text-zinc-500">
				{/* The router passes any thrown value through, so a non-Error must not crash this surface. */}
				{error instanceof Error ? error.message : null}
			</p>
			<button
				type="button"
				className="mt-4 rounded-lg bg-zinc-900 px-6 py-2 text-sm text-white"
				onClick={() => retryAfterError(error, reset)}
			>
				Try again
			</button>
		</div>
	);
}
